import {
  SnippetElement,
  defineElement,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-BMSK74LT.js";

// src/snippets/common-localization-modal/common-localization-modal.ts
var CommonLocalizationModal = class extends SnippetElement {
  onClose() {
    this.localizationModal.close();
  }
  onCountryClick(elm) {
    var _a;
    this.inputCountryCode.value = (_a = elm.dataset.value) != null ? _a : "";
    if (this.form) {
      this.form.submit();
    } else {
      console.log("failed to submit country form");
    }
  }
  onLanguageClick(elm) {
    var _a;
    this.inputLanguageCode.value = (_a = elm.dataset.value) != null ? _a : "";
    if (this.form) {
      this.form.submit();
    } else {
      console.log("failed to submit language form");
    }
  }
};
__decorateClass([
  query("[data-input-country-code]")
], CommonLocalizationModal.prototype, "inputCountryCode", 2);
__decorateClass([
  query("[data-input-language-code]")
], CommonLocalizationModal.prototype, "inputLanguageCode", 2);
__decorateClass([
  query("[data-country-button]")
], CommonLocalizationModal.prototype, "countryButtons", 2);
__decorateClass([
  query("[data-language-button]")
], CommonLocalizationModal.prototype, "languageButtons", 2);
__decorateClass([
  query("[localization-modal]")
], CommonLocalizationModal.prototype, "localizationModal", 2);
__decorateClass([
  query("form")
], CommonLocalizationModal.prototype, "form", 2);
__decorateClass([
  onClick("[data-country-button]")
], CommonLocalizationModal.prototype, "onCountryClick", 1);
__decorateClass([
  onClick("[data-language-button]")
], CommonLocalizationModal.prototype, "onLanguageClick", 1);
CommonLocalizationModal = __decorateClass([
  defineElement("common-localization-modal")
], CommonLocalizationModal);
export {
  CommonLocalizationModal
};
